<div class="dialog-header">
  <span class="spacer"></span>
  <span class="header-label">Extended Warranty Selection</span>
  <span class="spacer"></span>
  <button matButton="elevated" class="close-dialog-button warn-button" (click)="cancel()">
    X
  </button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="inputRow">
    <div>
      <span class="displayLabel">Select Refrigeration Warranty:</span>
      <br />
      <mat-radio-group [(ngModel)]="refrigerationRadioValue" (change)="updatePricing()" class="radio-group-vertical">
        <mat-radio-button [value]="">No Extended Warranty</mat-radio-button>
        @for (warranty of availableRefrigerationWarrantyCodes; track warranty) {
          <mat-radio-button [value]="warranty.code">
            {{ warranty.displayLabel }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <br />
    <div>
      <span class="displayLabel">Select Board Warranty:</span>
      <br />
      <mat-radio-group [(ngModel)]="boardRadioValue" (change)="updatePricing()" class="radio-group-vertical">
        <mat-radio-button [value]="">No Extended Warranty</mat-radio-button>
        @for (warranty of availableBoardWarrantyCodes; track warranty) {
          <mat-radio-button [value]="warranty.code" [checked]="this.boardRadioValue === warranty.code">
            {{ warranty.displayLabel }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </div>
  <div class="displayRow">
    <span class="displayLabel">Estimated Price:</span>
    <span class="valueLabel">{{ estimatedPrice | currency: "USD" }}</span>
  </div>
  <div class="disclaimerRow">
    <span class="disclaimerLabel">
      <p>Should the extended warranties be selected, the extended warranty will begin after the standard limited warranty period ends.</p>
      <p>Please refer to standard terms and conditions for more details.</p>
      <p>Extended warranty is based on base list price multplied by final multiplier.</p>
      <br />
      <ul class="disclaimer-footer">
        <li>
          Extended Refrigerant and Extended Control Warranties are not available on DOAS products.
        </li>
      </ul>
    </span>
  </div>
  @if (warningMessage) {
    <div class="warningMessage">
      {{ warningMessage }}
    </div>
  }
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="elevated" [disabled]="isBusy()" (click)="cancel()" class="inputButton warn-button">
      <mat-icon class="size-16">cancel</mat-icon>
      <span>Cancel</span>
    </button>
    <button matButton="elevated" [disabled]="changesDisabled()" class="inputButton primary-button" (click)="save()">
      <mat-icon class="size-16">save</mat-icon>
      <span>Save</span>
    </button>
  </div>
</div>
